import React from 'react';

import AssignmentsFieldLayout, { AssignmentInfo } from '../../../shared/widgets/AssignmentsFieldLayout';
import { FormFieldsData, useShowContextRequired } from 'ui-builder';
import { PlanTask } from 'nekst-api';
import { useProjectRolesLoader } from 'features/tasks-forms';

export interface AssignmentsFieldProps {
  source?: string;
  label?: string;
  filterFunc?: (data: FormFieldsData) => boolean;
}

export default function AssignmentsField(props: AssignmentsFieldProps) {
  const context = useShowContextRequired<PlanTask>();

  const {
    getRoleById,
    isLoaded,
  } = useProjectRolesLoader();

  if (props.source && isLoaded()) {
    const contextData = context.data;

    // @ts-ignore
    let value = contextData[props.source] as {
      projectRoleId: number,
      id: number
    }[];

    if (props.filterFunc) {
      value = value.filter(props.filterFunc);
    }

    const assignments: AssignmentInfo[] = value
      .filter((r) => !!getRoleById(r.projectRoleId))
      .map((r) => {
      return {
        id: `${contextData.id}-${r.projectRoleId}`,
        name: getRoleById(r.projectRoleId)!.name,
      };
    });

    if (assignments.length) {
      return (
        <AssignmentsFieldLayout
          label={props.label}
          assignments={assignments}
        />
      );
    } else {
      return null;
    }

  } else {
    return null;
  }
}
